angular
  .module('library')

  .filter('ratingsWeight', function() {
    return function(input) {
      var result = '';

      if (input.length > 0) {
        for (var i = 0; i < input.length; i++) {
          if (i > 0 && i < input.length) {
            result += '</br>';
          }

          result += input[i].type + ': ' + input[i].value;
        }
      }

      return result;
    };
  });
